import { Globals } from 'src/app/shared/services/globals';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(public global: Globals) { }

  ngOnInit() {
  }

}
